import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

import env from 'Env';
import imgixConfig from 'Config/imgix';
import store from 'Redux/store';

import 'Components/Banner/ExtensionMidPageBanner.scss';

export default function ExtensionMidPageBanner({ appearsOn }) {
  const extensionLink = `https://chromewebstore.google.com/detail/fanatical-pc-game-price-c/fifbkhhgkgphkjjnjkgdfknbkkgapnca?utm_source=LandingPage&utm_medium=referral&utm_source=fanatical.com&utm_campaign=${appearsOn}`;

  const bgImgSrc = `${env.cdnUrl}/browser-extension/banners/Fanatical-Assistant-MIDPAGE-CHARACTER-large.png`;

  const onLinkClick = () => {
    store.dispatch({
      type: 'frontend/click/CLICK_INTERACTION',
      payload: { section: 'ExtensionMidPageBanner', value: '' },
    });
  };

  if (!extensionLink) {
    return false;
  }

  return (
    <a
      href={extensionLink}
      target="_blank"
      rel="noopener noreferrer"
      role="button"
      onClick={() => onLinkClick()}
    >
      <div className="ExtensionMidPageBanner">
        <div className="ExtensionMidPageBanner__logoColumn">
          <div className="ExtensionMidPageBanner__logoTitle">
            <FormattedMessage id="ExtensionMidPageBanner.new-and-improved" defaultMessage="New and improved" />
          </div>
          <div className="ExtensionMidPageBanner__logo">
            <div className="ExtensionMidPageBanner__fullLogo">
              <FormattedMessage id="ExtensionMidPageBanner.fanaticalassistant" defaultMessage="Fanatical PC Game Price Comparison" />
            </div>
            <div className="ExtensionMidPageBanner__halfLogo">
              <FormattedMessage id="ExtensionMidPageBanner.fanatical" defaultMessage="Fanatical" />
            </div>
            <div className="ExtensionMidPageBanner__halfLogo">
              <FormattedMessage id="ExtensionMidPageBanner.assistant" defaultMessage="PC Game Price Comparison" />
            </div>
          </div>
          <div className="ExtensionMidPageBanner__logoSubTitle">
            <div>
              <FormattedMessage id="ExtensionMidPageBanner.browserextension" defaultMessage="Browser Extension" />
            </div>
          </div>
        </div>
        <div className="ExtensionMidPageBanner__textColumn">
          <div className="ExtensionMidPageBanner__textColumn__intro">
            <FormattedMessage
              id="ExtensionMidPageBanner.text.intro"
              defaultMessage="Never miss a great deal with The Fanatical Extension"
            />
          </div>
          <div className="ExtensionMidPageBanner__bulletListContainer">
            <div className="ExtensionMidPageBanner__bulletPoint">
              <FontAwesomeIcon icon={faCheck} />
              <div>
                <FormattedMessage id="ExtensionMidPageBanner.bullet.one" defaultMessage="Compare prices as you browse" />
              </div>
            </div>
            <div className="ExtensionMidPageBanner__bulletPoint">
              <FontAwesomeIcon icon={faCheck} />
              <div>
                <FormattedMessage id="ExtensionMidPageBanner.bullet.two" defaultMessage="Automatically apply coupons" />
              </div>
            </div>
            <div className="ExtensionMidPageBanner__bulletPoint">
              <FontAwesomeIcon icon={faCheck} />
              <div>
                <FormattedMessage id="ExtensionMidPageBanner.bullet.three" defaultMessage="Enchanced Privacy" />
              </div>
            </div>
            <div className="ExtensionMidPageBanner__bulletPoint">
              <FontAwesomeIcon icon={faCheck} />
              <div>
                <FormattedMessage id="ExtensionMidPageBanner.bullet.four" defaultMessage="Exclusive discounts" />
              </div>
            </div>
            <div className="ExtensionMidPageBanner__bulletPoint">
              <FontAwesomeIcon icon={faCheck} />
              <div>
                <FormattedMessage id="ExtensionMidPageBanner.bullet.five" defaultMessage="Safe and secure browser extension" />
              </div>
            </div>
          </div>
          <div className="ExtensionMidPageBanner__button">
            <div className="btn btn-primary">
              <FormattedMessage id="ExtensionMidPageBanner.button.try-now" defaultMessage="Install Now" />
            </div>
          </div>
        </div>

        <div className="ExtensionMidPageBanner__backgroundContainer">
          <img
            srcSet={`
              ${bgImgSrc}?${imgixConfig}&w=1324&h=477&fit=crop 1324w,
              ${bgImgSrc}?${imgixConfig}&w=1200&h=432&fit=crop 1200w,
            `}
            sizes="100vw"
            src={`${bgImgSrc}?${imgixConfig}&w=1324&h=477&fit=crop`}
            alt="Fanatical PC Game Price Comparison | Browser Extension"
          />
        </div>
      </div>
    </a>
  );
}

ExtensionMidPageBanner.propTypes = {
  appearsOn: PropTypes.string,
};

ExtensionMidPageBanner.defaultProps = {
  appearsOn: '',
};
